import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Forms.scss';

export default function FormContent({ children, type }) {
    return (<div className={styles[`form-content-${type}`]}>
        {children}
    </div>);
}

FormContent.displayName = displayName('Forms/FormContent');

FormContent.propTypes = {
    children: PropTypes.node.isRequired,
    type: PropTypes.oneOf(['block', 'inline', 'stacked']),
};

FormContent.defaultProps = {
    type: 'block',
};
